export default "__VITE_ASSET__BKOsXWI7__"